<template>
<temp-default>
    <div class="bl_form ly_form ly_form2Columns">
        <div class="bl_form_container ly_form_container ly_form2Columns__col1">
            <div class="bl_form_container_field ly_form_container_field">
                <div class="ly_form_container_field_col1">
                    <label class="bl_form_container_field_label">建築物用途</label>
                </div>
                <div class="ly_form_container_field_col2">
                    <app-radio
                        v-model="HouseOrBuilding"
                        value="House"
                        label="住宅"
                        name="HouseOrBuilding"
                    />
                    <app-radio
                        v-model="HouseOrBuilding"
                        value="Building"
                        label="非住宅"
                        name="HouseOrBuilding"
                    />
                </div>
            </div>
            <div class="bl_form_container_field ly_form_container_field">
                <div class="ly_form_container_field_col1">
                    <label class="bl_form_container_field_label">地域区分</label>
                </div>
                <div class="ly_form_container_field_col2 ly_form_container_field_col2__chiiki">
                    <app-radio
                        v-model="region"
                        value="1"
                        label="1地域"
                        name="region"
                    />
                    <app-radio
                        v-model="region"
                        value="2"
                        label="2地域"
                        name="region"
                    />
                    <app-radio
                        v-model="region"
                        value="3"
                        label="3地域"
                        name="region"
                    />
                    <app-radio
                        v-model="region"
                        value="4"
                        label="4地域"
                        name="region"
                    />
                    <app-radio
                        v-model="region"
                        value="5"
                        label="5地域"
                        name="region"
                    />
                    <app-radio
                        v-model="region"
                        value="6"
                        label="6地域"
                        name="region"
                    />
                    <app-radio
                        v-model="region"
                        value="7"
                        label="7地域"
                        name="region"
                    />
                    <app-radio
                        v-model="region"
                        value="8"
                        label="8地域"
                        name="region"
                    />
                </div>
            </div>
            <div class="bl_form_container_field ly_form_container_field ly_form_container_field__direction">
                <div class="ly_form_container_field_col1">
                    <label class="bl_form_container_field_label">外壁の方位
                    </label>
                </div>
                <div class="ly_form_container_field_col2 ly_form_container_field_col2__direction">
                    <app-radio
                        v-model="direction"
                        value="1"
                        label="北"
                        name="direction"
                    />
                    <app-radio
                        v-model="direction"
                        value="2"
                        label="北東"
                        name="direction"
                    />
                    <app-radio
                        v-model="direction"
                        value="3"
                        label="東"
                        name="direction"
                    />
                    <app-radio
                        v-model="direction"
                        value="4"
                        label="南東"
                        name="direction"
                    />
                    <app-radio
                        v-model="direction"
                        value="5"
                        label="南"
                        name="direction"
                    />
                    <app-radio
                        v-model="direction"
                        value="6"
                        label="南西"
                        name="direction"
                    />
                    <app-radio
                        v-model="direction"
                        value="7"
                        label="西"
                        name="direction"
                    />
                    <app-radio
                        v-model="direction"
                        value="8"
                        label="北西"
                        name="direction"
                    />
                </div>
                <div
                    v-if="this.window_width < 1000" class="ly_form2Columns__col3 bl_directionImgWrapper">
                    <div class="bl_directionImg">
                        <div class="bl_directionImg_connpass">
                            <div 
                            :class="{
                                'kita': this.direction == 1, 
                                'hokutou': this.direction == 2, 
                                'higashi': this.direction == 3, 
                                'nantou': this.direction == 4, 
                                'minami': this.direction == 5, 
                                'nansei': this.direction == 6, 
                                'nishi': this.direction == 7, 
                                'hokusei': this.direction == 8
                            }"
                            class="bl_directionImg_direction">外壁</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div
            v-if="this.window_width >= 1000" class="ly_form2Columns__col2 bl_directionImgWrapper">
            <div class="bl_directionImg">
                <div class="bl_directionImg_connpass">
                    <div 
                    :class="{
                        'kita': this.direction == 1, 
                        'hokutou': this.direction == 2, 
                        'higashi': this.direction == 3, 
                        'nantou': this.direction == 4, 
                        'minami': this.direction == 5, 
                        'nansei': this.direction == 6, 
                        'nishi': this.direction == 7, 
                        'hokusei': this.direction == 8
                    }"
                    class="bl_directionImg_direction">外壁</div>
                </div>
            </div>
        </div>
    </div>
    <div class="bl_form ly_form ly_form2Columns ly_form2Columns__sizes">
        <div class="bl_form_container ly_form_container ly_form2Columns__col1">
            <div class="bl_form_container_field ly_form_container_field ly_form_container_field__size">
                <div class="ly_form_container_field_col1">
                    <label class="bl_form_container_field_label title">サイドフィンの<br class="hp_viewpconly" />評価
                        <a href="https://house.lowenergy.jp/dictionary/shading-app#shading_type" target="_blank" rel="noopener noreferrer" class="el_helpButton">?</a>
                    </label>
                </div>
                <div class="ly_form_container_field_col2">
                    <app-radio
                        v-model="SideFin"
                        value="No"
                        label="サイドフィンを評価しない"
                        name="SideFin"
                    />
                    <app-radio
                        v-model="SideFin"
                        value="Yes"
                        label="サイドフィンを評価する"
                        name="SideFin"
                    />
                </div>
                <div
                    v-if="this.window_width < 1000"
                    class="ly_form2Columns__col3 bl_windowImg_wrapper">
                    <div 
                        :class="{
                            'box': checkSideFin(),
                            'over': !checkSideFin()
                            }"
                        class="bl_windowImg">
                        <div class="bl_windowImg_box"></div>
                        <div class="bl_windowImg_over"></div>
                    </div>
                </div>
            </div>
            <div class="bl_form__sizes bl_form_container_field ly_form_container_field">
                <label class="bl_form_container_field_label title" style="grid-row: 1 / 4; margin-bottom: 8px;">
                    外壁の各部分<br class="hp_viewpconly" />の長さ
                    <a href="https://house.lowenergy.jp/dictionary/shading-app#shading_length" target="_blank" rel="noopener noreferrer" class="el_helpButton">?</a>
                </label>
                <div class="bl_form__sizes_wrapper ly_form__sizes_wrapper">
                    <div class="bl_form__sizes_item">
                        <label class="bl_form_container_field_label">x<sub>1</sub></label>
                        <app-text-box
                            type="number"
                            name="x1"
                            v-model=x1
                            step="0.01"
                            unit="m"
                            :disabled="isDefault_x1"
                            :class="{'el_disabled':isDefault_x1}"
                        />
                        <label class="isDefault_wrapper">
                            <input type="checkbox" :class="{'isDefault_x1' : isDefault_x1}" @click="toggleDefault_x1" />
                            <span 
                            class="isDefault_wrapper_main" :class="{'isDefault_active' : isDefault_x1}">規定値(4m)を用いる</span>
                        </label>
                    </div>
                    <div class="bl_form__sizes_item">
                        <label class="bl_form_container_field_label">x<sub>2</sub></label>
                        <app-text-box
                            type="number"
                            name="x2"
                            v-model=x2
                            step="0.01"
                            unit="m"
                        />
                    </div>
                    <div class="bl_form__sizes_item">
                        <label class="bl_form_container_field_label">x<sub>3</sub></label>
                        <app-text-box
                            type="number"
                            name="x3"
                            v-model=x3
                            step="0.01"
                            unit="m"
                            :disabled="isDefault_x3"
                            :class="{'el_disabled':isDefault_x3}"
                        />
                        <label class="isDefault_wrapper">
                            <input type="checkbox" :class="{'isDefault_x3' : isDefault_x3}" @click="toggleDefault_x3" />
                            <span 
                            class="isDefault_wrapper_main" :class="{'isDefault_active' : isDefault_x3}">規定値(4m)を用いる</span>
                        </label>
                    </div>
                </div>
                <div class="bl_form__sizes_wrapper ly_form__sizes_wrapper">
                    <div class="bl_form__sizes_item">
                        <label class="bl_form_container_field_label">y<sub>1</sub></label>
                        <app-text-box
                            type="number"
                            name="y1"
                            v-model=y1
                            step="0.01"
                            unit="m"
                            :disabled="isDefault_y1 && SideFin == 'Yes'"
                            :class="{'el_disabled':isDefault_y1 && SideFin == 'Yes'}"
                        />
                        <label 
                        v-if="checkSideFin()"
                        class="isDefault_wrapper">
                            <input type="checkbox" :class="{'isDefault_y1' : isDefault_y1}" @click="toggleDefault_y1" />
                            <span 
                            class="isDefault_wrapper_main" :class="{'isDefault_active' : isDefault_y1}">入力しない（4m以上の場合）</span>
                        </label>
                    </div>
                    <div class="bl_form__sizes_item">
                        <label class="bl_form_container_field_label">y<sub>2</sub></label>
                        <app-text-box
                            type="number"
                            name="y2"
                            v-model=y2
                            step="0.01"
                            unit="m"
                        />
                    </div>
                </div>
                <div class="bl_form__sizes_wrapper ly_form__sizes_wrapper">
                    <div class="bl_form__sizes_item">
                        <label class="bl_form_container_field_label">z<sub>x+</sub></label>
                        <app-text-box
                            type="number"
                            name="zxplus"
                            v-model=zxplus
                            step="0.01"
                            unit="m"
                            :disabled="!checkSideFin()"
                        />
                    </div>
                    <div class="bl_form__sizes_item">
                        <label class="bl_form_container_field_label">z<sub>x-</sub></label>
                        <app-text-box
                            type="number"
                            name="zxminus"
                            v-model=zxminus
                            step="0.01"
                            unit="m"
                            :disabled="!checkSideFin()"
                        />
                    </div>
                    <div class="bl_form__sizes_item">
                        <label class="bl_form_container_field_label">z<sub>y+</sub></label>
                        <app-text-box
                            type="number"
                            name="zyplus"
                            v-model=zyplus
                            step="0.01"
                            unit="m"
                        />
                    </div>
                    
                </div>
            </div>
        </div>
        <div
            v-if="this.window_width >= 1000"
            @click="toggleWindowImg"
            :class="{'uq_modal':isShowWindowImg}"
            class="ly_form2Columns__col2 bl_windowImg_wrapper">
            <div 
                :class="{
                    'box': checkSideFin(),
                    'over': !checkSideFin()
                    }"
                class="bl_windowImg">
                <div class="bl_windowImg_box"></div>
                <div class="bl_windowImg_over"></div>
                <p
                    v-if="!checkSideFin()"
                    class="bl_windowImg_wrapper_title bl_windowImg_wrapper_title__box">サイドフィンを評価しない場合</p>
                <p 
                    v-if="checkSideFin()" class="bl_windowImg_wrapper_title bl_windowImg_wrapper_title__over">サイドフィンを評価する場合</p>
                <p v-if="isShowWindowImg" class="uq_modal_message">クリックして入力画面に戻る</p>
            </div>
        </div>
    </div>
</temp-default>
</template>

<script>
import AppRadio from '@/components/atoms/AppRadio.vue'
import AppTextBox from '@/components/atoms/AppTextBox.vue'
import TempDefault from '@/components/templates/TempDefault.vue'
import { mapActions, mapGetters } from 'vuex'
import { mapComputedProperties } from '@/util'

export default {
    name: 'Index',
    components: {
        AppRadio,
        AppTextBox,
        TempDefault
    },
    computed:{
        ...mapGetters({
            data:'getAll'
        }),
        ...mapComputedProperties([
            'HouseOrBuilding',
            'region',
            'direction',
            'x1',
            'x2',
            'x3',
            'y1',
            'y2',
            'zxplus',
            'zxminus',
            'zyplus',
            'SideFin',
            'calculated',
            'window_width',
            'isShowWindowImg',
        ])
    },
    mounted() {
        window.addEventListener('resize', this.handleResize)
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize)
    },
    methods: {
        ...mapActions([
            'update'
        ]),
        handleResize() {
            this.width = window.innerWidth;
            this.height = window.innerHeight;
        },
        showWindowImg() {
            this.isShowWindowImg = true
        },
        hideWindowImg() {
            this.isShowWindowImg = false
        },
        toggleWindowImg() {
            this.isShowWindowImg = !this.isShowWindowImg
        },
        toggleDefault_x1(){
            if (this.isDefault_x1) {
                this.x1 = 1;
            } else {
                // input要素のtypeがnumberである場合、デフォルト値に文字列は使えない
                // （送信時に文字列"Default"に書き換える）
                this.x1 = null;
            }
            this.isDefault_x1 = !this.isDefault_x1
        },
        toggleDefault_x3(){
            if (this.isDefault_x3) {
                this.x3 = 1;
            } else {
                // input要素のtypeがnumberである場合、デフォルト値に文字列は使えない
                // （送信時に文字列"Default"に書き換える）
                this.x3 = null;
            }
            this.isDefault_x3 = !this.isDefault_x3
        },
        toggleDefault_y1(){
            if (this.isDefault_y1) {
                this.y1 = 1;
            } else {
                // input要素のtypeがnumberである場合、デフォルト値に文字列は使えない
                // （送信時に文字列"Default"に書き換える）
                this.y1 = null;
            }
            this.isDefault_y1 = !this.isDefault_y1
        },
        checkSideFin() {
            if (this.SideFin == "Yes") {
                return true;
            } else if (this.SideFin == "No") {
                return false;
            }
        }
    },
    watch: {
        SideFin(newValue) {
            if(newValue == 'No') {
                this.zxplus = 0
                this.zxminus = 0
                this.isDefault_y1 = false
                this.y1 = 1
            } else if (newValue == 'Yes') {
                this.y1 = null
                this.isDefault_y1 = true
            }
        },
    },
    data(){
        return{
            isDefault_x1: true,
            isDefault_x3: true,
            isDefault_y1: true,
        }
    }
}
</script>

<style lang="scss" scoped>
.el_helpButton{
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    width: 14px;
    height: 14px;
    margin: 0 16px;
    padding: 2px;
    font-size: 12px;
    line-height: 12px;
    font-weight: bolder;
    text-align: center;
    color: #fff;
    background-color: #178eaa;
    border-radius: 8px;
    border: none;
    -webkit-box-shadow: none;
    box-shadow: none;
    cursor: pointer;
    margin: 0 0.25rem;
}
.ly_form__sizes_wrapper{
    display: flex;
    flex-direction: column;
    width: 100%;
}
.bl_form__sizes_item{
    display: grid;
    grid-template-columns: 3em 8em 1fr;
    justify-content: center;
    align-items: baseline;
    width: 100%;
    margin-bottom: 3px;
    padding: 0 0 6px;
    border-bottom: 1px solid #efefef;
}
.bl_form__sizes_wrapper:first-of-type label{
    color: #0071BC;
}
.bl_form__sizes_wrapper:nth-of-type(2) label{
    color: #3EAC4A;
}
.bl_form__sizes_wrapper:last-of-type label{
    color: #BA262B;
}
.bl_form__sizes_item .bl_form_container_field_label{
    display: inline-block;
    font-size: 20px;
    text-align: left;
}
.bl_form_container_field_label.title{
    display: inline;
    width: 100%;
    align-items: center;
}
.ly_form_container_field_col2.ly_form_container_field_col2__chiiki{
    display: grid;
    grid-template-columns: repeat(auto-fit,minmax(80px,1fr));
}
.ly_form_container_field_col2.ly_form_container_field_col2__direction{
    display: grid;
    grid-template-columns: repeat(auto-fit,minmax(80px,1fr));
}


.ly_form_container_field_col2.ly_form_container_field_col2__chiiki .el_radio{
    margin: 0;
}
/* 方位とタイプ */
.bl_directionImgWrapper{
    width: 130px;
    height: 150px;
    margin: 0 auto;
}
.bl_directionImg,
.bl_windowImg{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    margin: 0 auto;
    position: relative;
}
.bl_directionImg_direction{
    display: inline-block;
    width: 80px;
    height: 66px;
    color: transparent;
    background-image: url(/img/all_img.png);
    background-repeat: no-repeat;
    background-size: auto 485px;
    background-position-x: 58.95%;
    background-position-y: 0;
    position: absolute;
    transform-origin: 40px 60px;
    transform: rotate(90deg);
    top: 15px;
    left: 25px;
    transition: transform ease .3s;
    z-index: 20;
    &.kita{
        transform: rotate(0deg);
    }
    &.hokutou{
        transform: rotate(45deg);
    }
    &.higashi{
        transform: rotate(90deg);
    }
    &.nantou{
        transform: rotate(135deg);
    }
    &.minami{
        transform: rotate(180deg);
    }
    &.nansei{
        transform: rotate(225deg);
    }
    &.nishi{
        transform: rotate(270deg);
    }
    &.hokusei{
        transform: rotate(315deg);
    }
}
.bl_directionImg_connpass{
    display: inline-block;
    width: 125px;
    height: 140px;
    color: transparent;
    background-image: url(/img/all_img.png);
    background-repeat: no-repeat;
    background-size: auto 485px;
    background-position-x: 50.5%;
    background-position-y: 0%;
    position: absolute;
}
.bl_windowImg_wrapper{
    width: 100%;
    overflow: hidden;
}
.bl_windowImg_wrapper .bl_windowImg_wrapper_title{
    display: inline-block;
    font-weight: bolder;
}
.bl_windowImg_wrapper.uq_modal{
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    background-color: rgba(255, 255, 255, .9);
    width: 100%;
    height:100vh; 
    padding: 50px;
    top:0;
    left: 0;
    position: fixed;
    z-index: 1000;
}
.bl_windowImg_wrapper.uq_modal .uq_modal_message{
    display: inline-block;
}
.bl_windowImg_wrapper.uq_modal .bl_windowImg{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin: 0;
}
.bl_windowImg_wrapper.uq_modal .bl_windowImg.over{
    transition: none;
    transform: translateX(0);
}
.bl_windowImg_wrapper.uq_modal .bl_windowImg.box .bl_windowImg_over{
    display: none;
}
.bl_windowImg_wrapper.uq_modal .bl_windowImg.box .bl_windowImg_box{
    width: 800px;
    height: 550px;
    margin: 0 auto;
    background-size: auto 970px;
}
.bl_windowImg_wrapper.uq_modal .bl_windowImg.over .bl_windowImg_box{
    display: none;
}
.bl_windowImg_wrapper.uq_modal .bl_windowImg.over .bl_windowImg_over{
    width: 800px;
    height: 550px;
    margin: 0 auto;
    background-size: auto 970px;
}
.bl_windowImg{
    display: flex;
    justify-content: flex-start;
    width: auto;
    overflow: visible;
    transition: all ease .3s;
}
.bl_windowImg.box{
    transform: translateX(10px);
}
.bl_windowImg.over{
    transform: translateX(-390px);
}
.bl_windowImg_box,
.bl_windowImg_over{
    display: inline-block;
    width: 400px;
    min-width: 400px;
    height: 270px;
    margin: 0;
    color: transparent;
    background-image: url(/img/all_img.png);
    background-repeat: no-repeat;
    background-size: auto 485px;
    background-position-x: 0;
    background-position-y: 67%;
}
.bl_windowImg_box{
    background-position-x: 0%;
}
.bl_windowImg_over{
    background-position-x: 39%;
}
_:-ms-lang(x)::-ms-backdrop, .bl_windowImg_wrapper{
    width: 300px;
}
_:-ms-lang(x)::-ms-backdrop, .bl_directionImg{
    align-items: flex-start;
}
_:-ms-lang(x)::-ms-backdrop, .bl_directionImg_connpass{
    margin-left: 16px;
}
_:-ms-lang(x)::-ms-backdrop, .bl_form__sizes_item .bl_form_container_field_label{
    display: inline-block;
    width: 1.25em;
    min-width: 1.25em;
}
.isDefault_wrapper{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    row-gap: 4px;
    width: 100%;
    margin-bottom: 4px;
    font-size: 14px;
    line-height: 14px;
}
.isDefault_wrapper input[type="checkbox"]{
    display: none;
}
.isDefault_wrapper span.isDefault_wrapper_main{
    display: inline-flex;
    align-items: flex-start;
    width: 100%;
    padding: 2px 0 0 20px;
    color: #1C4373;
    position: relative;
}

.isDefault_wrapper span.isDefault_wrapper_main:before{
    content: "";
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 14px;
    height: 14px;
    min-width: 14px;
    min-height: 14px;
    margin-right: 4px;
    border: #ccc solid 1px;
    background-color: white;
    border-radius: 2px;
    position: absolute;
    left: 0px;
    top: 2px;
}
.isDefault_wrapper .isDefault_active{
    font-weight: bolder;
}
.isDefault_wrapper .isDefault_active:after{
    content: "";
    width: 10px;
    height: 6px;
    border-left: 2px solid #178eaa;
    border-bottom: 2px solid #178eaa;
    transform: rotate(-35deg);
    position: absolute;
    left: 2px;
    top: 4px;
}


/* レスポンシブ（タブレット縦よりウインドウ幅が狭いもの） */
@media screen and (max-width: 1000px) {
    .hp_viewpconly{
        display: none;
    }
    .ly_form_container_field__direction{
        grid-template-columns: 1fr 130px;
        grid-template-rows: 25px auto;
    }
    .ly_form_container_field__direction .ly_form2Columns__col3{
        grid-column: 2;
        grid-row: 1 / 3;
    }
    .ly_form_container_field__size{
        grid-template-columns: 1fr;
    }
    .ly_form_container_field__size .ly_form2Columns__col3{
        grid-column: 1;
        grid-row: 3;
    }
    .bl_form__sizes_wrapper.ly_form__sizes_wrapper{
        min-width: 160px;
        padding: 8px 2px;
    }
    .ly_form_container_field__flex{
        justify-content: flex-start;
    }
    .bl_directionImg, .bl_windowImg{
        justify-content: flex-start;
        flex-direction: column;
    }
    .bl_windowImg.box,
    .bl_windowImg.side,
    .bl_windowImg.over{
        transform: translateX(0px);
    }
    .bl_windowImg.box .bl_windowImg_side,
    .bl_windowImg.box .bl_windowImg_over{
        display: none;
    }
    .bl_windowImg.side .bl_windowImg_box,
    .bl_windowImg.side .bl_windowImg_over{
        display: none;
    }
    .bl_windowImg.over .bl_windowImg_box,
    .bl_windowImg.over .bl_windowImg_side{
        display: none;
    }
}

/* レスポンシブ（タブレット縦よりウインドウ幅が狭いもの） */
@media screen and (max-width: 605px) {
    .bl_form__sizes_wrapper.ly_form__sizes_wrapper{
        min-width: 180px; 
        border-left: none;
    }
    _:-ms-lang(x)::-ms-backdrop, .ly_form_container_field__flex{
        flex-direction: column;
    }
}
</style>